import { FormFieldAutocomplete } from 'global/components/Form'
import { useFormContext } from 'react-hook-form'
import { centroCusto } from 'service/api'
import { useStore } from 'store'

type IProps = {
    className?: string
}

export function FormAutocompleteCentroCusto({ className }: IProps) {
    const empresaId = useStore(state => state.companyId)

    const context = useFormContext()

    if (!context) {
        throw new Error('Contexto de formulário não encontrado')
    }

    const { data = [] } = centroCusto.useFetch({
        queryParams: { empresaId },
    })

    return (
        <div className={className}>
            <FormFieldAutocomplete
                name="FuncionarioCentroCusto.CentroCusto"
                label="Centro de custo"
                options={data}
                getOptionLabel={option =>
                    option.nomeCentroCusto + ' - ' + option.codigo
                }
            />
        </div>
    )
}
